import React, { useEffect, useState } from 'react';

import DatePickerDefault from '../../common/DatePickerDefault';
import IssTab from '../../common/IssTab';
import IssTabs from '../../common/IssTabs';
import IssueHistoryContentsCommon from './IssueHistoryContentsCommon';
import IssueHistoryContentsTotal from './IssueHistoryContentsTotal';
import IconButton from '../../common/IconButton';
import DropDownForSearch from '../../common/DropDownForSearch';
import DefaultButton from '../../common/DefaultButton';
import RadioChartFilter from '../../common/RadioChartFilter';

import { getHeaders } from '../../../../util/actionUtil';
import { ISS_BASE_URL } from '../../../../constants/index';
import Alert from '../../modal/Alert';

const IssueHistoryContents = ({ filterCallback }) => {
  const [pageCurrentTab, pageClickTab] = useState(0);

  const [regions, setRegions] = useState({'dropdownList': [], 'checkedList' : []});
  const [countries, setCountries] = useState({'dropdownList': [], 'checkedList' : []});
  const [providers, setProviders] = useState({'dropdownList': [], 'checkedList' : []});

  const [paramRegions, setParamRegions] = useState([]);
  const [paramCountries, setParamCountries] = useState([]);
  const [paramProviders, setParamProviders] = useState([]);
  const [searchFilter, setSearchFilter] = useState({});

  const [currentFilter, setCurrentFilter] = useState({ subType: '', date: '', country: '', provider: '', platform: '' });

  const [isAlert, setIsAlert] = useState(false);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [calendarValue, setCalendarValue] = useState([]);  // [startDate, endDate] eg, 2023-08-20, 2023-09-19
  const [isDateShow, setDateShow] = useState(true);
  const [defaultDate, setDefaultDate] = useState([]);

  const [downloadDataType, setDownloadDataType] = useState('');
  const [isDownloadFlag, setDownloadFlag] = useState(false);
  const [chartType, setChartType] = useState('Line');

  const subTypeName = ['All', 'feed', 'admin', 'batch'];
  //------------------------------------
  //tab 관련
  //------------------------------------
  const tabMenus = [
    {
      name: 'All',
      tooltip: '',
    },
    {
      name: 'CP',
      tooltip: '',
    },
    {
      name: 'CMP Organization',
      tooltip: '',
    },
    {
      name: 'Data Deployment',
      tooltip: '',
    }
  ];

  useEffect(() => {
    defaultRangeDate();
    getSearchFilter();
  }, []);

  useEffect(() => {
    if ( searchFilter.countryByRegion ) {
      let dropdownCountries = [];
      if (paramRegions && paramRegions.length > 0){
        dropdownCountries = searchFilter.countryByRegion.filter(f => paramRegions.includes(f.region)).map(region =>
          region.countryList.map(map => ({ id: map.countryCode, value : map.fullName }))).reduce(function (acc, cur) { return acc.concat(cur); });
        dropdownCountries.sort((a, b) => a.value.localeCompare(b.value));
      }
      // Unknown
      if (dropdownCountries.length > 0) {
        dropdownCountries.push({ id: 'Unknown', value : 'Unknown' });
      }

      setCountries({'dropdownList': dropdownCountries, 'checkedList' : [] });
    }
  }, [ paramRegions ]);

  useEffect(() => {
    if ( searchFilter.countryByRegion &&  searchFilter.providerByCountry) {
      let dropdownProviders = [];
      if (paramCountries && paramCountries.length > 0 && paramCountries.filter(item => item != 'Unknown').length > 0) {
        let ProviderList = searchFilter.providerByCountry.filter(f => paramCountries.filter(item => item != 'Unknown').includes(f.countryCode)).map(map =>
          map.providerList.map(pr => ({ id: pr.providerId, value : pr.providerName }))).reduce(function (acc, cur) { return acc.concat(cur); });
        dropdownProviders = [...new Set(ProviderList.map((list) => JSON.stringify(list)))].map((list) => JSON.parse(list));
      }
      setProviders({ 'dropdownList': dropdownProviders, 'checkedList' : [] });
    }
  }, [ paramCountries ]);

  useEffect(() => {
    if (currentFilter.date.length > 0) {
      filterCallback(currentFilter);
    }
  }, [currentFilter]);

  useEffect(() => {
    setDateShow(true);
    setCurrentFilter({ subType: subTypeName[pageCurrentTab], date: calendarValue, country: '', provider: '', platform: '' });
    setDownloadDataType('');
    setDownloadFlag(false);
  }, [pageCurrentTab]);

  useEffect(() => {
    setDownloadFlag(false);
  }, [isDownloadFlag]);

  const getSearchFilter = () => {
    fetch(`${ISS_BASE_URL}/api/common/search-filter`, {
      method: 'GET',
      headers: getHeaders(),
    })
    .then(res => res.json())
    .then(body => {
      if (body.result === 'SUCCESS') {
        setSearchFilter({
          countryByRegion : body.countryByRegion
          , providerByCountry : body.providerByCountry
        })
        let dropdownRegion = [];
        // countryByRegion
        if ( body.countryByRegion ) {
          dropdownRegion = body.countryByRegion.map(map =>({ id: map.region, value : map.region }));
          dropdownRegion.sort((a, b) => a.value.localeCompare(b.value));
        }
        setRegions({ 'dropdownList': dropdownRegion, 'checkedList' : [] });
      } else {
        setAlertTitle('Error');
        setAlertMessage('[getSearchFilter : error]');
        setIsAlert(true);
      }
    })
    .catch(error => {
      console.log("getSearchFilter - error: " , error);
      setAlertTitle('Error');
      setAlertMessage('[getSearchFilter : error]');
      setIsAlert(true);
    }).finally(() => {});
  };

  // Default date는 30일
  const defaultRangeDays = 30; // 달력에 날짜를 보여 주기 위한 default 일자, 30일
  const defaultRangeDate = () => {
    const today = new Date();
    const utcToday = new Date(today.toUTCString());

    const thirtyDaysAgo = new Date(utcToday);
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - defaultRangeDays);

    const utcTodayString = utcToday.toISOString().substring(0, 10);
    const thirtyDaysAgoString = thirtyDaysAgo.toISOString().substring(0, 10);

    setDefaultDate([thirtyDaysAgoString, utcTodayString]); // [startDate, endDate]
  };

  const tabChangeHandler = (selectedIdx, _data) => {
    if (pageCurrentTab !== selectedIdx) {
      setDateShow(false);
      setParamProviders([]);
      setParamCountries([]);
      setParamRegions([]);
      setCalendarValue(defaultDate);
      setCurrentFilter({ date: '', country: '', provider: '', platform: '' });
      pageClickTab(selectedIdx);
    }
  };

  const issueSearchByButton = () => {
    setDownloadDataType('');

    if (pageCurrentTab === 1 && (paramRegions.length === 0 || paramCountries.length === 0 || paramProviders.length === 0)) {
      const showMessage = paramRegions.length === 0 ? 'region' : paramCountries.length === 0 ? 'country' : 'cp';
      setAlertTitle('Warning');
      setAlertMessage(`Please select any ${showMessage}`);

      onOpenAlert();
    } else {
      setCurrentFilter({ subType: subTypeName[pageCurrentTab], date: calendarValue, country: paramCountries, provider: paramProviders, platform: '' });
    }
  };

  const onOpenAlert = () => {
    setIsAlert(true);
  };

  const onCloseAlert = () => {
    setIsAlert(false);
  };

  const excelDownload = () => {
    setDownloadDataType('excel');
    setDownloadFlag(true);
  };

  const pdfDownload = () => {
    setDownloadDataType('pdf');
    setDownloadFlag(true);
  };

  const chartChangeHandler = value => {
    setChartType(value);
  };

  return (
    <>
      <div className="ui-components">
        <div className="box-left">
          <div className="ui-datepicker-box">
            {
              isDateShow === true ? (
                <DatePickerDefault dateChangeHandler={(newDate) => setCalendarValue(newDate)} />
              ) : (
                <></>
              )}
          </div>
          <div className="ui-dropdown-box">
            {pageCurrentTab === 1 ? (
              <>
                <DropDownForSearch dropDownItem={regions} title="Region" onChangeDropDown={setParamRegions} />
                <DropDownForSearch dropDownItem={countries} title="Countries" onChangeDropDown={setParamCountries} />
                <DropDownForSearch dropDownItem={providers} title="CPs" onChangeDropDown={setParamProviders} />
              </>
            ) : (
              <></>
            )}
            <DefaultButton type={'button'} text={'Search'} btnClass={'btn-search'} clickEvent={issueSearchByButton} />
            <div style ={{ padding:'0px 0px 0px 15px', border: '1px solid rgba(255, 255, 255, 0.2)', borderRadius: '10px' }}>
              <RadioChartFilter chartType={chartType} onChangeRadio={chartChangeHandler} />
            </div>
          </div>
        </div>
      </div>

      <div className="tab-container">
        <div className="box-btns">
          {
            pageCurrentTab !== 0 ? (
              <IconButton type={'button'} text={'Excel Download'} btnClass={'btn-icon-download'} clickEvent={excelDownload} />
            ) : (
              <>
              </>
            )
          }
        </div>

        <IssTabs tabMenus={tabMenus} currentTab={pageCurrentTab} className={'ui-tab-type03'} onChange={tabChangeHandler}>
          <IssTab isActive={true}>
            {
              isDownloadFlag === false ? (
                pageCurrentTab === 0 ? (
                  <IssueHistoryContentsTotal currentFilter={currentFilter} chartType={chartType} />
                ) : (
                  <IssueHistoryContentsCommon pageCurrentTab={pageCurrentTab} currentFilter={currentFilter} downloadDataType={downloadDataType} chartType={chartType} />
                )
              ) : (
                <></>
              )
            }
          </IssTab>
        </IssTabs>
      </div>
      {isAlert && <Alert isOpen={isAlert} title={alertTitle} message={alertMessage} onClose={onCloseAlert} />}
    </>
  );
};

export default IssueHistoryContents;
